import { Tooltip } from '@sparemin/blockhead';
import cn from 'classnames';
import React from 'react';
import Button, { ButtonProps } from 'components/Button';
import { block } from './utils';

export type SocialButtonSize = 'large' | 'small';

export interface SocialButtonProps
  extends Pick<ButtonProps, 'disabled' | 'onClick' | 'params'> {
  className?: string;
  icon: React.ReactNode;
  label: string;
  size?: SocialButtonSize;
  tooltip?: string;
}

const SocialButton: React.FC<SocialButtonProps> = ({
  className,
  disabled,
  onClick,
  icon,
  label,
  params,
  size,
  tooltip,
}) => {
  const button = (
    <Button
      className={cn(block({ [size]: !!size }), className)}
      {...{ disabled, onClick, params }}
    >
      <div className={block('icon')}>{icon}</div>
      <span className={block('label')}>{label}</span>
    </Button>
  );

  if (!tooltip) {
    return button;
  }

  return (
    <Tooltip arrow contents={tooltip} placement="top" strategy="fixed">
      {/* Wrapper allows hover detection for the tooltip when the button is disabled */}
      <div className={block('tooltip-wrapper')}>{button}</div>
    </Tooltip>
  );
};

export default SocialButton;
